<template>
    <hts-slide-over
        :show="props.show"
        color="main"
        :submit="handleSubmitFormEdit"
        :width="20"
        :title="$t('labels.editOrderRequest')"
        :undo-enable="true"
        @close="closeOverSide"
        @undo="undo()">
        <template #body>
            <div class="hts-vehicles-ignore-add-vehicle">
                <div class="hts-vehicles-ignore-add-vehicle__container-body">
                    <hts-card>
                        <template #title>
                            <h3 class="title">
                                <hi-backward-icon class="icon overturned" />
                                <span class="label">
                                    {{ $t('labels.generalInformation') }}
                                </span>
                            </h3>
                        </template>
                        <div
                            class="grid gap-4"
                            :class="columnClass">
                            <hts-form-autocomplete
                                v-model="dataFormEdit.commodity"
                                :text="dataFormEdit.commodityName"
                                :label="$t('labels.selectCommodity')"
                                :server="serverCommodity"
                                key-id="_id"
                                key-label="name"
                                :placeholder="$t('labels.selectCommodity')"
                                :add="false" />
                            <hts-form-input
                                v-model="dataFormEdit.cargoWeightKG"
                                :label="$t('labels.cargoWeightKG')"
                                :color="props.color"
                                type="number"
                                name="name"
                                prop="name" />

                            <hts-form-input
                                v-model="dataFormEdit.volume"
                                :label="$t('labels.volume')"
                                :color="props.color"
                                name="description"
                                type="number"
                                prop="description" />

                            <hts-form-checkbox
                                v-model="dataFormEdit.isReefer"
                                :items="checkIsReefer" />
                        </div>
                    </hts-card>
                </div>
            </div>
        </template>
    </hts-slide-over>
</template>

<script setup lang="ts">
import form from './imports/form'
const serverCommodity = $urlClient.commodity.commodity.select
const dataFormEdit: { [key: string]: any } = ref({})

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
    required: true
  },
  color: {
    type: String,
    default: 'theme'
  },
  sizeSlideOver: {
    type: String,
    default: 'small'
  },
  sizeItemInput: {
    type: String,
    default: 'small'
  },
  column: {
    type: Number,
    default: 1
  },
  orderRequest: {
    type: Object
  }
})

const emits = defineEmits(['close', 'refreshTables'])

const closeOverSide = () => {
  emits('close')
}

watch(props, () => {
  _init()
})

const _init = () => {
  dataFormEdit.value = { ...props.orderRequest }
  dataFormEdit.value.commodity = props.orderRequest?.commodity?._id || null
  dataFormEdit.value.commodityName = props.orderRequest?.commodity?.name || null
}

const undo = () => {
  _init()
}

const handleSubmitFormEdit = () => {
  const api = $urlClient.order.orderRequest.update

  $api(api, { uriParams: { ID: props.orderRequest?._id }, body: dataFormEdit.value }).then((data) => {
    const resData: any = data?.data.value || null

    if (resData?.success) {
      emits('refreshTables')
      process.client && $toast().success($t('labels.editSuccess', { name: $t('labels.orderRequest') }))
      emits('close')
      undo()
    }
  })
}

const columnClass = computed(() => {
  if ($lodash.inRange(props.column, 1, 12)) {
    return `grid-cols-${props.column}`
  }

  return 'grid-cols-1'
})

const checkIsReefer = [
  {
    key: 'isReefer',
    title: $t('labels.isReefer')
  }
]
</script>
